import { render, staticRenderFns } from "./UserCreateReport.vue?vue&type=template&id=966d9610&scoped=true&"
import script from "./UserCreateReport.vue?vue&type=script&lang=js&"
export * from "./UserCreateReport.vue?vue&type=script&lang=js&"
import style0 from "./UserCreateReport.vue?vue&type=style&index=0&id=966d9610&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966d9610",
  null
  
)

export default component.exports